module.exports = __webpack_public_path__ + "img/markerTramGreen.915782bd.svg";